import { Box, styled } from "@mui/material";
import moment from "moment";
import { useEffect, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { defaultLanguage, languages } from "../../i18n";
import auth from "../../services/auth/AuthService";
import LoadingSpinner from "../progress/LoadingSpinner";
import SideBar from "../sidebar/Sidebar";
import Topbar from "../topbar/Topbar";

const MainContainer = styled(Box)(() => ({
    display: "flex",
    flexDirection: "row",
    overflowX: "hidden",
    overflowY: "scroll",
    height: "100%",
    width: "100%",
}));

const ContentContainer = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
}));

const MainLayout = () => {
    const location = useLocation();
    useEffect(() => {
        moment.locale(languages.get(auth.user?.language || defaultLanguage));
    }, []);

    const routesWithoutPadding = ["route/add", "route/edit"];
    const isRoutesWithoutPadding = useMemo(() => {
        return routesWithoutPadding.some(route => location.pathname.includes(route));
    }, [location.pathname]);

    const ScrollContainer = styled(Box)(() => ({
        width: "100%",
        height: "100%",
        paddingLeft: isRoutesWithoutPadding ? 0 : 16,
        paddingRight: isRoutesWithoutPadding ? 0 : 16,
        paddingTop: isRoutesWithoutPadding ? 0 : 16,
        overflowX: "hidden",
        overflowY: "scroll",
        position: "relative"
    }));

    return (
        <MainContainer>
            <SideBar />
            <ContentContainer>
                <Topbar />
                <LoadingSpinner />
                <ScrollContainer>
                    <Outlet />
                </ScrollContainer>
            </ContentContainer>
        </MainContainer>

    );
};

export default MainLayout;